<mar-analysis-card
	[icon]="icon()"
	[label]="label()"
	[types]="types()"
	[tooltip]="tooltip()"
	[currency]="currency()"
	(typeChange)="onTypeChange($event)"
>
	<div class="flex h-full flex-col gap-3 flex-1">
		<div class="flex items-center flex-row gap-4 mt-3">
			@if (targets !== null && !hideTarget()) {
				<div class="w-12 flex-0"></div>
			}
			<div class="flex flex-1 flex-row gap-1.5 w-full">
				@for (
					item of [].constructor(inputData().length);
					track $index
				) {
					<div class="flex items-center justify-center w-full">
						<p class="font-semibold">
							{{ 'analysis.q.' + ($index + 1) | transloco }}
						</p>
					</div>
				}
			</div>
		</div>

		@for (value of displayData(); track value.id) {
			<div class="flex items-center flex-row gap-4">
				@if (targets !== null && !hideTarget()) {
					<div class="w-12 flex-0">
						<p class="text-xs font-semibold">
							{{ value.label | transloco }}
						</p>
					</div>
				}

				<div class="flex flex-1 flex-row gap-1.5 h-12 w-full">
					@for (data of value.data; track data.id) {
						@switch (type()) {
							@case ('percent') {
								<mar-distribution-box
									[tuiHint]="data.percent"
									[code]="data.code"
								>
									{{ data.percent }}
								</mar-distribution-box>
							}
							@case ('sum') {
								<mar-distribution-box
									[tuiHint]="data.value"
									[code]="data.code"
								>
									{{ data.value }}
								</mar-distribution-box>
							}
							@case ('dollar') {
								@if (
									data.value
										| currencyAmount
											: {
													currency: currency(),
													round: true,
											  };
									as formatted
								) {
									<mar-distribution-box
										[tuiHint]="formatted"
										[code]="data.code"
									>
										@if (
											data.value
												| dollarShorthand: currency();
											as value
										) {
											{{ value }}
										} @else {
											{{ formatted }}
										}
									</mar-distribution-box>
								}
							}
						}
					}
				</div>
			</div>

			@if (!$last) {
				<div class="flex items-center flex-row gap-4">
					@if (targets !== null) {
						<div class="w-12 flex-0"></div>
					}
					<div class="flex-1 mar-divider"></div>
				</div>
			}
		}
	</div>
</mar-analysis-card>
